import './index.scss';
import './popup';
import './step/initial_data';
import './step/kid';
import './step/select_enter_data';
import './step/ban';
import './step/processing';
import './step/doc_gen';
import './step/docs_for_sign';
import './step/docs_sms_sign';
import './step/final';

const globalStore = useGlobalStorage();
const notifications = globalStore?.notifications;

BX.Vue.component('aos', {
  data: function () {
    return {
      aos: null,
      layout: null,
      layoutForm: null,
      animate: null,
      isLoaded: false,
      isEmailValidate: false,
      theme: 'light',
      toast: {
        duration: 500,
        showDuration: 30000,
        element: null,
      },
      content: {
        initialData: {
          checkbox: null,
          sopd: null,
          options: null,
        },
        selectEnterData: {
          checkbox: null,
        },
      },
      step: null,
      stepData: {},
      stepFirst: null,
      stepComponentList: {
        INITIAL_DATA: 'aos__initial-data',
        KID: 'aos__kid',
        SELECT_ENTER_DATA: 'aos__select-enter-data',
        DOC_GEN: 'aos__doc-gen',
        PROCESSING: 'aos__processing',
        BAN: 'aos__ban',
        DOCS_FOR_SIGN: 'aos__docs-for-sign',
        DOCS_SMS_SIGN: 'aos__docs-sms-sign',
        FINAL: 'aos__final',
      },
      banTitle: null,
      banText: null,
      title: null,
      titleClass: null,
      processEndText: null,
      ocfStepClass: null,
      options: {
        timeoutConnection: 60,
        timeoutConnectionPR: 60,
        captcha: null,
        errorDelay: 6000,
        animateSpeedAll: 300,
        animateSpeedSect: 100,
        loader: {
          color: '-v2',
        },
        answer: {
          color: 'dark-blue',
        },
        timeout: {
          delay: 300,
        },
      },
      bitrixComponent: {
        passport: null,
        enterDataForm: null,
        ideas: null,
      },
      plugins: {
        datepicker: '/local/js/jquery/datepicker/dist/datepicker.js',
      },
      clientData: {},
      phone: null,
      changeInfoPopup: null,
    };
  },
  methods: {
    msg: function (code) {
      return BX.aBase.msg(code);
    },
    titleReset: function () {
      let vm = this;
      vm.title = vm.msg('A_AOS_SECTION_TITLE');
      vm.titleClass = '';
    },
    captchaInit: (vm, callback) => {
      let form = document.querySelector('.ocf__step form');
      if (vm.captcha === null) {
        vm.captcha = new AtonCaptcha(form, {
          classes: {
            buttons: 'phone-confirm',
            field: 'form__field',
            form: 'form',
          },
        });
        vm.captcha.init(callback);
      } else vm.captcha.reload(callback);
    },
    checkEmptyField: function (input, value) {
      value = typeof value !== 'undefined' && value !== null ? value : input.value;
      if (value !== '' && !input.classList.contains('__filled')) {
        input.classList.add('__filled');
      } else if (value === '' && input.classList.contains('__filled')) {
        input.classList.remove('__filled');
      }
    },
    appendMess: function (obj, messageCode, isText) {
      let vm = this;
      obj = vm.getField(obj);

      if (!obj) {
        return false;
      }

      vm.addError(obj);
      let error = obj.querySelector('.form__error-tip');

      if (!error) {
        error = document.createElement('div');
        error.className = 'form__error-tip';
        obj.appendChild(error);
      }

      let message = isText === true ? messageCode : vm.msg(messageCode);

      if (error) {
        error.innerHTML = message;
      }
    },
    addError: function (obj) {
      let vm = this;
      obj = vm.getField(obj);

      if (!obj) {
        return false;
      }

      let clsError = vm.getClassError(obj);

      let clsSuccess = '__success';
      obj.classList.remove(clsSuccess);
      if (!obj.classList.contains(clsError)) {
        obj.classList.add(clsError);
        let rowColumns = obj.closest('.row__columns');
        if (rowColumns) {
          rowColumns.classList.add(clsError);
        }
      }
    },
    removeError: function (obj) {
      let vm = this;
      let objField = obj;
      obj = vm.getField(obj);

      if (!obj) {
        return false;
      }

      let clsError = vm.getClassError(obj);
      let clsSuccess = '__success';

      if (obj.classList.contains(clsError)) {
        let error = obj.querySelector('.form__error-tip');

        setTimeout(() => {
          if (error) error.innerHTML = '&nbsp;';
        }, 300);

        obj.classList.remove(clsError);
        let rowColumns = obj.closest('.row__columns');
        if (rowColumns) {
          if (!rowColumns.querySelector('.' + clsError)) {
            rowColumns.classList.remove(clsError);
          }
        }
      }
      if (objField.value !== '') {
        obj.classList.add(clsSuccess);
      } else {
        obj.classList.remove(clsSuccess);
      }
    },
    getClassError: function (obj) {
      return obj.classList.contains('form__chbox')
        ? 'form__chbox_error'
        : 'form__field_error';
    },
    getField: function (obj) {
      // Узла может не быть: клик по подсказке приходит из глобального обработчика,
      // который ищет поле по разметке адресных полей и для «Кем выдан» отдаёт null
      if (!obj || !obj.classList) {
        return null;
      }

      return obj.classList.contains('form__field') ||
        obj.classList.contains('form__chbox')
        ? obj
        : obj.type === 'checkbox'
          ? obj.closest('.form__chbox')
          : obj.closest('.form__field');
    },
    blurLoader: function (obj, state) {
      let vm = this;

      if (!obj) {
        return false;
      }

      if (state === true) {
        vm.blur(obj, true);
        BX.aLoader.startLoader(obj, vm.options.loader.color);
      } else {
        BX.aLoader.stopLoader(obj);
        vm.blur(obj, false);
      }
    },
    blur: function (obj, state) {
      let clsLoading = 'ocf__section-loading';

      if (!obj) {
        return false;
      }

      if (state === true) {
        obj.classList.add(clsLoading);
      } else {
        obj.classList.remove(clsLoading);
      }
    },
    btnLoader: function (obj, state) {
      let clsLoading = 'clicked';

      if (!obj) {
        return false;
      }

      if (state === true) {
        obj.classList.add(clsLoading);
      } else {
        obj.classList.remove(clsLoading);
      }
    },
    timeoutAnimate: function (callback, time) {
      let vm = this;
      if (typeof callback === 'function') {
        setTimeout(callback, time ? time : vm.options.timeout.delay);
      }
    },
    processCSS: function (block, callback) {
      if (block && block.STYLE && block.STYLE.length > 0) {
        BX.load(block.STYLE, callback);

        return true;
      }

      return false;
    },
    processScripts: function (block) {
      if (block && block.SCRIPT && block.SCRIPT.length > 0) {
        BX.ajax.processScripts(block.SCRIPT);

        return true;
      }

      return false;
    },
    processHTML: function (html) {
      let vm = this;

      if (!html) {
        return false;
      }

      let ob = BX.processHTML(html);
      vm.processScripts(ob);
      vm.processCSS(ob);

      return ob.HTML;
    },
    scrollToElement: function (el, ms, top) {
      let vm = this;
      let $el = typeof el === 'string' ? document.querySelector(el) : el;

      if (!$el) {
        return false;
      }

      if (window?.innerWidth > 991) {
        let target = document.querySelector('._layout_form');

        target?.scrollTo({
          top: vm.findPosition($el),
          behavior: 'smooth',
        });
      } else {
        window.scrollTo({
          top: vm.findPosition($el),
          behavior: 'smooth',
        });
      }
    },
    findPosition: function (obj) {
      let currenttop = 0;
      if (obj.offsetParent) {
        do {
          currenttop += obj.offsetTop;
        } while ((obj = obj.offsetParent));
        return [currenttop];
      }
    },
    stringReplaceAt: function (string, index, replacement) {
      string += '';
      return (
        string.substr(0, index) + replacement + string.substr(index + replacement.length)
      );
    },
    toggleEaseOutAnimation: function (state, obj, params) {
      state = state === true;
      params = typeof params === 'object' ? params : null;

      if (state) {
        obj.style.opacity = params && params.opacity ? params.opacity : 1;
        obj.style.height = params && params.height ? params.height : 'auto';
        obj.style.margin = params && params.margin ? params.margin : null;
        obj.style.padding = params && params.padding ? params.padding : null;
      } else {
        obj.style.opacity = params && params.opacity ? params.opacity : 0;
        obj.style.height = params && params.height ? params.height : 0;
        obj.style.margin = params && params.margin ? params.margin : 0;
        obj.style.padding = params && params.padding ? params.padding : 0;
      }
    },
    initSteps: function () {
      let vm = this;

      vm.blurLoader(vm.$refs['_aos'], true);
      BX.ajax
        .runComponentAction('aton:aos', 'initialData', {
          url: location.pathname,
          method: 'post',
          mode: 'class',
          data: {
            clearCache: location.search.indexOf('clear_cache=Y') !== -1 ? 'y' : 'n',
          },
        })
        .then(function (request) {
          if (request.status === 'success') {
            let requestData = request.data;

            vm.content.initialData.checkbox = requestData.initialData.data.checkbox;
            vm.content.initialData.sopd = requestData.initialData.data.sopd;
            vm.content.initialData.options = requestData.initialData.data.options;

            vm.content.selectEnterData.checkbox =
              requestData.selectEnterData.data.checkbox;
            vm.bitrixComponent.passport =
              requestData.selectEnterData.data.bitrixComponent.passport;
            vm.bitrixComponent.enterDataForm =
              requestData.selectEnterData.data.bitrixComponent.enterDataForm;
            vm.bitrixComponent.ideas =
              requestData.selectEnterData.data.bitrixComponent.ideas;

            vm.options.timeoutConnection = parseInt(
              requestData.options.connectionTimeout,
            );
            vm.options.timeoutConnectionPR = parseInt(
              requestData.options.connectionTimeoutPR,
            );
            vm.options.captcha = requestData.options.captcha || null;

            vm.isLoaded = true;

            let sectionTitle = vm.$refs['_aos'].querySelector('.ocf__section-title');
            sectionTitle.style.display = 'block';
            vm.blurLoader(vm.$refs['_aos'], false);
          } else {
            vm.blurLoader(vm.$refs['_aos'], false);
          }
        })
        .catch(function () {
          vm.blurLoader(vm.$refs['_aos'], false);
        });
    },
    errorAjaxMessage: function (message) {
      let vm = this;
      BX.aBase.initAnswer(
        vm.msg('A_AOS_ERROR_TITLE'),
        message ? message : vm.msg('A_AOS_ERROR_MESSAGE'),
        vm.msg('A_AOS_ERROR_BUTTON_CLOSE'),
        null,
        vm.options.answer.color,
      );
    },
    messageError: function (message, title, obj) {
      let vm = this;
      message = message ? message : vm.msg('A_AOS_ERROR_MESSAGE');
      title = title ? title : vm.msg('A_AOS_TOAST_TITLE');
      notifications?.addNotification(
        'danger',
        title,
        message,
        '',
        () => {},
        '',
        null,
        vm.toast.showDuration,
      );
    },
    removeMessageError: function (obj) {
      notifications?.removeNotification();
    },
    sendAOSBIAction: function (variable) {
      BX.ajax
        .runComponentAction('aton:aos', 'sendAOSBI', {
          url: location.pathname,
          method: 'post',
          mode: 'class',
          data: {
            variable: variable,
          },
        })
        .then(function (request) {
          if (
            request.status === 'success' &&
            request.data.ymGoalCode &&
            typeof ym !== 'undefined'
          ) {
            ym(28725931, 'reachGoal', request.data.ymGoalCode);
          }
        });
    },
  },
  mounted: function () {
    let vm = this;
    document.querySelector('#popup-window')?.classList.add('-v2024', '-aside');
    document.body.classList.add('-hide');
    document.body.classList.remove('-final');
    vm.aos = vm.$refs['_aos'];
    vm.layout = vm.$refs['_aos'].closest('._layout');
    vm.layoutForm = vm.layout.querySelector('._layout_form');
    vm.stepFirst = Object.keys(vm.stepComponentList)[0];
    vm.step = vm.step ? vm.step : vm.stepFirst;
    vm.title = vm.msg('A_AOS_SECTION_TITLE');
    vm.initSteps();
    vm.removeMessageError();
    vm.scrollToElement('._aos', 0);
  },
  watch: {
    step(current, _) {
      let vm = this;

      vm.ocfStepClass = null;

      if (vm.layout) {
        [...vm.layout.classList].forEach((c) => {
          if (c !== '_layout') vm.layout.classList.remove(c);
        });

        const layoutModCls = vm.step ? '-' + vm.step.toLowerCase() : '';
        vm.layout?.classList.add(layoutModCls);
      }

      switch (current) {
        case 'SELECT_ENTER_DATA':
          vm.layout?.classList.add('-minimized');
          break;
        case 'DOCS_FOR_SIGN':
          vm.layout?.classList.add('-minimized');
          break;
        default:
          vm.layout?.classList.remove('-minimized');
      }
    },
  },
  template: `
          <section ref="_aos" class="aos__section aos" id="aos" :data-theme="theme">
          <div class="container-2024">
            <h1 class="ocf__section-title h2" v-bind:class="titleClass ? titleClass : ''" id="ocf__section-title" v-html="title"/>
            <div class="ocf__step" :class="ocfStepClass" v-if="isLoaded">
              <component v-if="stepComponentList[step]" v-bind:is="stepComponentList[step]"></component>
            </div>
          </div>
          </section>
        `,
});
